"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheMap = void 0;
class CacheMap {
    constructor(ttlSeconds, loader) {
        this.ttlSeconds = ttlSeconds;
        this.loader = loader;
        this.map = new Map();
    }
    getFromCache(ident) {
        const item = this.map.get(ident);
        if (item == null) {
            return null;
        }
        if (item.cacheTime + this.ttlSeconds * 1000 < new Date().getTime()) {
            this.map.delete(ident);
            return null;
        }
        return item.data;
    }
    getFromCacheOrLoad(ident) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.loader == null) {
                console.warn("define loader for cached map ", ident);
                return null;
            }
            const item = this.map.get(ident);
            if (item == null) {
                const loadedItem = yield this.loader(ident);
                if (loadedItem == null) {
                    return null;
                }
                this.setItem(ident, loadedItem);
                return loadedItem;
            }
            if (item.cacheTime + this.ttlSeconds * 1000 < new Date().getTime()) {
                this.map.delete(ident);
                const loadedItem = yield this.loader(ident);
                if (loadedItem == null) {
                    return null;
                }
                this.setItem(ident, loadedItem);
                return loadedItem;
            }
            return item.data;
        });
    }
    setItem(ident, data) {
        this.map.set(ident, { cacheTime: new Date().getTime(), data });
    }
    removeCachedItem(ident) {
        this.map.delete(ident);
    }
    clearCache() {
        this.map = new Map();
    }
}
exports.CacheMap = CacheMap;
